import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.323 5.75h5.486c1.883 0 3.405 1.4 3.405 3.125 0 1.726-1.522 3.125-3.404 3.125M7.322 5.75V12m0-6.25H5.5m1.823 12.5h7.264c1.883 0 3.413-1.4 3.413-3.125C18 13.399 16.47 12 14.587 12H7.323m0 6.25V12m0 6.25H5.5"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.798 3.75h6.912c2.372 0 4.29 1.847 4.29 4.125S16.082 12 13.71 12M6.798 3.75V12m0-8.25H4.5m2.298 16.5h9.152c2.372 0 4.3-1.847 4.3-4.125S18.322 12 15.95 12H6.798m0 8.25V12m0 8.25H4.5"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.595 7.5H26.42c4.743 0 8.58 3.694 8.58 8.25S31.163 24 26.42 24M12.595 7.5V24m0-16.5H8m4.595 33H30.9c4.743 0 8.6-3.694 8.6-8.25S35.643 24 30.9 24H12.595m0 16.5V24m0 16.5H8"
  }))
};
export var FormatBold = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});